(function () {
    'use strict';
    var controllerId = 'cndPCorso2B';
    angular.module('app').controller(controllerId, ['common', '$scope', '$rootScope', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '_', 'commonAttach', fn_cndPCorso2B]);

    function fn_cndPCorso2B(common, $scope, $rootScope, bDialog, $routeParams, modal, datacontext, sectionMenu, _, commonAttach) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.title = 'Percorsi Formativi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.ableIssue = true;
        vm.objName = "CNDCorso"; //Utilizzato per pannello authorization
        vm.authorization = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.risorsa = {};

        vm.confirm = {};
        vm.corsoMod = {};
        vm.corsoModSpec = {};

        vm.pageWizard = 1;
        vm.pageMaxWizard = 6;
        vm.lastPageWizard = vm.pageWizard;
        vm.pageWizardTitle = [];
        vm.setPageWizard = setPageWizard;
        vm.wizardCompleted = false;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.bMaxOre = true;
        vm.minAllievi = 18;

        //Elenco per Ordinamento

        vm.list = {};
        vm.list.ordine = ['data ricevuta', 'data protocollo', 'ragione sociale'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        vm.getRecord = getRecord;
        vm.getListAttach = getListAttach;
        vm.disableCompleted = true;
        vm.changeStateAttach = commonAttach.changeStateAttach;
        vm.extractCADESFile = commonAttach.extractCADESFile;
        vm.extractVerifySignInfo = commonAttach.extractVerifySignInfo;
        vm.safeDownload = commonAttach.safeDownload;

        //Elenchi dettaglio
        vm.list.attach = [];
        vm.tSourceCode_def = 'CRS_2B';
        vm.list.b_attach = false;

        vm.list.b_materie = false;
        vm.list.b_classi = false;

        //Filtro
        vm.filter = {};

        vm.fTestuale = '';
        vm.fTMisuraCode = '2B';
        vm.fPartecipazioneId = 0;
        vm.fAPLId = 0;
        vm.fIStato = 0;

        vm.filter.testuale = vm.fTestuale;
        vm.filter.tMisuraCode = vm.fTMisuraCode;
        vm.filter.partecipazioneId = vm.fPartecipazioneId;
        vm.filter.aplId = vm.fAPLId;
        vm.filter.iStato = vm.fIStato;

        vm.fAttach = {};
        vm.setfAttach = setfAttach;
        vm.filterAttach = '';
        vm.fAttach.TAttachId = '';

        //Elenchi per filtri e finestra modale di Create
        vm.tSource = {};
        vm.tAttach = [];

        vm.cmblist = {};

        vm.cmblist.APL = [];
        vm.cmblist.tPercorsi = [];
        vm.cmblist.tFigProfessionali = [];
        vm.cmblist.tProfiloDocenti = [];
        vm.cmblist.tTitoloStudio = [];

        vm.cmblist.entiSubordinati = [];


        //----------------ANOMALIE-------------------------------------
        vm.setIssue = setIssue;
        vm.unsetIssue = unsetIssue;
        vm.setIssueCPISolved = setIssueCPISolved;
        vm.setIssueAPLSolved = setIssueAPLSolved;

        vm.setPresaIncarico = setPresaIncarico;
        vm.unsetPresaIncarico = unsetPresaIncarico;
        vm.setPresaIncaricoCPI = setPresaIncaricoCPI;
        vm.unsetPresaIncaricoCPI = unsetPresaIncaricoCPI;

        //IssuesLog
        vm.list.issueUMCLog = [];
        vm.list.issueCPILog = [];
        vm.list.issueLog = [];
        vm.addIssueLog = addIssueLog;
        vm.getListIssuesLog = getListIssuesLog;
        vm.setIState = setIState;
        vm.deleteIssueLog = deleteIssueLog;

        //stampa anomalie
        vm.printAnomalie = printAnomalie;
        //----------------FINE ANOMALIE--------------------------------

        // #region Localizzazione

        vm.cmblist.paesi = [];
        vm.cmblist.province = [];
        vm.cmblist.provinceSic = [];
        vm.cmblist.tIndirizzi = [];

        vm.getPaesi = function () {
            if (vm.cmblist.paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi = data;
            });
        };
        vm.getProvince = function () {
            if (vm.cmblist.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province = data;
            });
        };
        vm.getProvinceSic = function () {
            if (vm.cmblist.provinceSic.length > 0) return;

            datacontext.arrProvinceByReg(19).then(function (data) {
                vm.cmblist.provinceSic = data;
            });
        };
        vm.getTIndirizzi = function () {
            if (vm.cmblist.tIndirizzi.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi = data;
            });
        };

        vm.cmblist.paesi_sedeSvolg = [];
        vm.cmblist.province_sedeSvolg = [];
        vm.cmblist.comuni_sedeSvolg = [];
        vm.cmblist.tIndirizzi_sedeSvolg = [];

        //-- SedeSvolg_PaeseId, SedeSvolg_ComuneId
        vm.change_Paesi_Svolg = function () {
            if (vm.record.SedeSvolg_PaeseId > 0) {
                vm.record.SedeSvolg_ComuneId = 0;
                vm.record.SedeSvolg_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_Svolg = function (idProv) {
            vm.record.SedeSvolg_ComuneId = '';
            vm.getComuni_Svolg(idProv);
        };
        vm.getComuni_Svolg = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeSvolg = [];
            if (vm.record.SedeSvolg_ProvinciaId != idprov) vm.cmblist.comuni_sedeSvolg = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeSvolg = data;
            });
        };
        vm.getPaesi_Svolg = function () {
            if (vm.cmblist.paesi_sedeSvolg.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeSvolg = data;
            });
        };
        vm.getProvince_Svolg = function () {
            if (vm.cmblist.province_sedeSvolg.length > 0) return;

            datacontext.arrProvinceByReg(19).then(function (data) {
                vm.cmblist.province_sedeSvolg = data;
            });
        };
        vm.getTIndirizzi_Svolg = function () {
            if (vm.cmblist.tIndirizzi_sedeSvolg.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeSvolg = data;
            });
        };


        // #endregion

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VERIFICA ORE ATTIVITA' -#-#-#-#-#-#
        vm.isOverOreTot = false;
        vm.isOverOre = false;
        vm.change_oreAttivita = function () {
            var sum = 0;
            var maxSum = vm.record.Ore == 0 ? 1056 : vm.record.Ore;

            if (vm.record.A1_Ore >= 0) {
                sum += vm.record.A1_Ore;
            }
            if (vm.record.A2_Ore >= 0) {
                sum += vm.record.A2_Ore;
            }

            vm.isOverOreTot = false;
            //Se A1 + A2 > OreTot
            if (sum > maxSum) {
                vm.isOverOreTot = true;
            }

            var sumA2 = 0;
            var maxSumA2 = vm.record.A2_Ore;
            if (vm.record.A2a_Ore >= 0) {
                sumA2 += vm.record.A2a_Ore;
            }
            if (vm.record.A2b_Ore >= 0) {
                sumA2 += vm.record.A2b_Ore;
            }

            vm.isOverOre = false;
            //Se A2a + A2b > A2
            if (sumA2 > maxSumA2) {
                vm.isOverOre = true;
            }
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VERIFICA ORE ATTIVITA' ARTICOLATO -#-#-#-#-#-#
        vm.isOverOreTotFP = false;
        vm.isOverOreFP = false;
        vm.change_oreAttivitaFP = function () {
            var sumFP = 0;
            var maxSumFP = vm.record.Ore == 0 ? 1056 : vm.record.Ore;

            if (vm.record.A1_FP_Ore >= 0) {
                sumFP += vm.record.A1_FP_Ore;
            }
            if (vm.record.A2_FP_Ore >= 0) {
                sumFP += vm.record.A2_FP_Ore;
            }

            vm.isOverOreTotFP = false;
            //Se A1_FP + A2_FP > OreTotFP
            if (sumFP > maxSumFP) {
                vm.isOverOreTotFP = true;
            }

            var sumA2FP = 0;
            var maxSumA2FP = vm.record.A2_FP_Ore;
            if (vm.record.A2a_FP_Ore >= 0) {
                sumA2FP += vm.record.A2a_FP_Ore;
            }
            if (vm.record.A2b_FP_Ore >= 0) {
                sumA2FP += vm.record.A2b_FP_Ore;
            }

            vm.isOverOreFP = false;
            //Se A2a_FP + A2b_FP > A2_FP
            if (sumA2FP > maxSumA2FP) {
                vm.isOverOreFP = true;
            }
        };

        vm.change_Articolato_TFigProf = function () {
            if (vm.record.M2B_Articolato_TFigProfId > 0 && vm.cmblist.tFigProfessionali.length > 0) {
                var tFigProf = _.filter(vm.cmblist.tFigProfessionali, { 'Id': vm.record.M2B_Articolato_TFigProfId })[0];
                vm.record.M2B_Articolato_TFigProf = tFigProf.Name;
            }
        };

        vm.change_Articolato = function () {
            if (!vm.record.M2B_bArticolato) {
                vm.record.M2B_Articolato_TFigProfId = 0;
            }
        }

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;


        vm.goNext = goNext;
        vm.goPrev = goPrev;
        vm.PrevWizard = PrevWizard;
        vm.NextWizard = NextWizard;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.merge = mergeItem;
        vm.delete = deleteItem;
        vm.download = downloadItem;

        vm.stepCompiled = stepCompiled;

        vm.pageWizardTitle.push('1 - STRUTTURA PERCORSO FORMATIVO');
        vm.pageWizardTitle.push('2 - OBIETTIVI E ARTICOLAZIONE ATTIVIT\xC0 ');
        vm.pageWizardTitle.push('3 - DETTAGLIO ARTICOLAZIONE PERCORSO');
        vm.pageWizardTitle.push('4 - ALLEGATO 5 - ELENCO ALLIEVI AMMESSI');
        vm.pageWizardTitle.push('5 - ALLEGATO 6 - ELENCO PERSONALE DOCENTE');
        vm.pageWizardTitle.push('6 - RIEPILOGO');


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.DtStartPrev = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.DtEndPrev = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [
                getAuthorization()
                , $rootScope.getRisorsa(vm)
                , getAPL()
                , getTPercorsi()
                , getTFigProfessionali()
                , getTProfiliDocenti()
                , getTTitoloStudio()
                , getTSource(vm.tSourceCode_def)
                , getTAttach(vm.tSourceCode_def)
                , getEntiSubordinati()
                //Localizzazioni 
                , vm.getPaesi()
                , vm.getProvince()
                , vm.getProvinceSic()
                , vm.getTIndirizzi()
                , vm.getPaesi_Svolg()
                , vm.getProvince_Svolg()
                , vm.getTIndirizzi_Svolg()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    vm.activated = true;
                    if ($routeParams.CNDPCorso2BId != null) {
                        setView('detail');
                        getRecord($routeParams.CNDPCorso2BId, 0);
                    }

                    cerca();
                });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.tMisuraCode = vm.fTMisuraCode == null ? '' : vm.fTMisuraCode;
            vm.filter.partecipazioneId = vm.fPartecipazioneId == null ? 0 : vm.fPartecipazioneId;
            vm.filter.aplId = vm.fAPLId == null ? 0 : vm.fAPLId;
            vm.filter.iStato = vm.fIStato == null ? 0 : vm.fIStato;

            vm.loading = false;

            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.pCorso_countAll(vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.partecipazioneId, vm.filter.aplId, vm.filter.iStato).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.pCorso_getAll(vm.pageSize, vm.page, vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.partecipazioneId, vm.filter.aplId, vm.filter.iStato, "").then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function () {
                //Auth. specifica
                //vm.isSpecial = (vm.isSUPER || vm.isUMC || vm.isCIAPI);
                if (vm.isUMC || vm.isFAM) {
                    //Di Default "Con ricevuta"
                    vm.fIStato = 5;
                }
            });
        }

        function setRecord(data, pageWiz) {
            //console.info('setRecord()', data);
            vm.record = data;

            if (vm.record.DtStartPrev != null) vm.record.DtStartPrev = new Date(vm.record.DtStartPrev);
            if (vm.record.DtEndPrev != null) vm.record.DtEndPrev = new Date(vm.record.DtEndPrev);

            if (vm.record.SedeSvolg_TIndirizzoId == 0) vm.record.SedeSvolg_TIndirizzoId = 1;
            if (vm.record.SedeEsame_TIndirizzoId == 0) vm.record.SedeEsame_TIndirizzoId = 1;

            if ((vm.record.SedeSvolg_PaeseId == null || vm.record.SedeSvolg_PaeseId == 0)
                && (vm.record.SedeSvolg_ComuneId == undefined || vm.record.SedeSvolg_ComuneId == null || vm.record.SedeSvolg_ComuneId == 0))
                vm.record.SedeSvolg_ComuneId = '';

            vm.minAllievi = 18;
            if (vm.record.bComuneMontano) {
                vm.minAllievi = 15;
            }

            vm.getComuni_Svolg(vm.record.SedeSvolg_ProvinciaId);

            vm.getModuloSummary(vm.record.PCMod);
            vm.record.PCModChanged = false;

            vm.getModuloSpecSummary(vm.record.PCModSpec);
            vm.record.PCModSpecChanged = false;

            vm.record.PCAllievoChanged = false;
            vm.record.PCDocenteChanged = false;

            vm.validPIVA = true;
            vm.validCF = true;
            vm.bMaxOre = true;

            vm.change_oreAttivita();
            vm.change_oreAttivitaFP();
            vm.change_Articolato_TFigProf();

            //Azzera filtri
            vm.list.attach = [];
            vm.list.b_attach = false;

            vm.filterAttach = '';
            vm.fAttach.TAttachId = '';

            vm.getListAttach(vm.record.Id);

            // #region Gestione Wizard
            vm.wizardCompleted = false;
            vm.pageWizard = 1;
            vm.lastPageWizard = 1;

            if (pageWiz != null && pageWiz != '' && typeof pageWiz != 'undefined') { //Ho salvato in bozza
                vm.pageWizard = pageWiz;
            }

            if (vm.record.PCDocenti != null && vm.record.PCDocenti.length > 0) {
                vm.wizardCompleted = true;
            }

            if (vm.record.Completed || vm.wizardCompleted) {
                vm.pageWizard = vm.pageMaxWizard;
                vm.lastPageWizard = vm.pageMaxWizard;
            }
            // #endregion
        }

        function getRecord(id, index) {
            return datacontext.pCorso_get(id).then(function (data) {
                vm.index = index;
                setRecord(data);

                setView('detail');
            });
        }

        function goNext() {
            if (vm.index + 1 >= vm.countRecords) return;
            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                getByFilter();
            }
            if (!vm.records) return;

            vm.index++;
            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        function goPrev() {
            if (vm.index == 0) return;
            if (!vm.records) return;

            vm.index--;

            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        // #region GESTIONE WIZARD
        function PrevWizard(recordForm) {
            if (vm.record.Completed && !vm.isSpecial)
                return;

            if (vm.pageWizard <= 1) return;
            vm.pageWizard--;

            return vm.pageWizard;
        }

        function NextWizard(recordForm) {
            if (typeof recordForm != 'undefined' || recordForm != null) {
                if (recordForm.$invalid) return;
            }
            if (vm.pageWizard >= vm.pageMaxWizard) return;


            vm.pageWizard++;
            vm.lastPageWizard = vm.pageWizard;

            if (vm.pageWizard == vm.pageMaxWizard)
                vm.wizardCompleted = true;



            return vm.pageWizard;
        }


        function setPageWizard(value) {
            if ((vm.record.Completed || !vm.stepCompiled(value)) && !vm.isSpecial)
                return;

            if (value > vm.lastPageWizard)
                return;

            vm.pageWizard = value;
        }

        function stepCompiled(value) {
            if (value < vm.pageWizard)
                return true;
            for (var locPageWizard = vm.pageWizard; locPageWizard < value; locPageWizard++) {
                var retVal = false;
                if (locPageWizard != 5 && locPageWizard != 6) {
                    retVal = true;
                } else if (locPageWizard == 5) {
                    if (vm.record.PCAllievi != null && vm.record.PCAllievi.length > 0)
                        retVal = true;
                } else if (locPageWizard == 6) {
                    if (vm.record.PCDocenti != null && vm.record.PCDocenti.length > 0)
                        retVal = true;
                }

                if (!retVal)
                    return false;
            }
            return true;
        }

        // #endregion

        function addRecord(id) {
            return datacontext.pCorso_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            if (vm.record.Ore == '' || typeof vm.record.Ore == 'undefined' || vm.record.Ore == null) vm.record.Ore = 0;
            if (vm.record.Mesi == '' || typeof vm.record.Mesi == 'undefined' || vm.record.Mesi == null) vm.record.Mesi = 0;
            return datacontext.pCorso_update(vm.record).then(function (data) {
                if (data == "400") {
                    logError('Si \xE8 verificato un errore. ');
                    return 400;
                }
                if (data == "409") return logError('Errore! Nome Corso esistente!!');
                if (data == "406") return logError('Errore! Inserire tutti gli allegati richiesti!!');
                if ($.isNumeric(data)) return logError('Errore server!');

                setRecord(data);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function mergeItem() {
            if (vm.record.Ore == '' || typeof vm.record.Ore == 'undefined' || vm.record.Ore == null) vm.record.Ore = 0;
            if (vm.record.Mesi == '' || typeof vm.record.Mesi == 'undefined' || vm.record.Mesi == null) vm.record.Mesi = 0;
            return datacontext.pCorso_merge(vm.record).then(function (data) {
                if (data == "400") {
                    logError('Si \xE8 verificato un errore. ');
                    return 400;
                }
                if (data == "409") return logError('Errore! Nome Corso esistente!!');
                if (data == "406") return logError('Errore! Inserire tutti gli allegati richiesti!!');
                if ($.isNumeric(data)) return logError('Errore server!');

                setRecord(data, vm.pageWizard);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function deleteItem(item) {
            var msg = ' Percorso: ' + item.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pCorso_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;

                    return logSuccess('Record cancellato ');
                });
            });
        }

        function downloadItem(item) {
            $('#loadingModal').modal('show');
            return datacontext.attach_download(item.Id, vm.tSourceCode_def, 0, 0).then(function (data) {
                $('#loadingModal').modal('hide');
                if (data == '') return logError('Documentazione non disponibile.');
                var url = data;
                window.open(url, 'Download');
            });
        }

        vm.setCompleted = function () {
            if (!vm.record.Completed)
                bDialog.confirmationDialog('Salva e convalida', 'Attenzione, si sta "SALVANDO e CONVALIDANDO" il percorso. Successivamente, non sar\xE0 possibile apportare modifiche. Si desidera procedere?', 'Procedi').then(
                    function () { //YES
                        vm.record.Completed = true;
                        return datacontext.pCorso_merge(vm.record).then(function (data) {
                            if (typeof data == undefined || $.isNumeric(data)) {
                                vm.record.Completed = false;
                                if ($.isNumeric(data)) {
                                    var msg = 'Attenzione, si \xE8 verificato un errore che ha impedito il salvataggio, ';
                                    switch (data) {
                                        case -2:
                                            msg += 'il numero di allievi deve essere compreso tra "' + vm.minAllievi + '" e "27" (sia nel wiz. 1 e sia nel wiz. 4). ';
                                            break;
                                        case -3:
                                            msg += 'il numero di allievi inserito non coincide con il numero dichiarato (sia nel wiz. 1 e sia nel wiz. 4). ';
                                            break;
                                        case -4:
                                            msg += 'il numero di ore eccede il massimo previsto (wiz. 1). ';
                                            break;
                                        case -5:
                                            msg += 'il numero di mesi eccede il massimo previsto (max 12 - wiz. 1). ';
                                            break;
                                        case -6:
                                            msg += 'la somma delle ore di Area 1 e Area 2 non coincide con le ore totali (wiz. 2). ';
                                            break;
                                        case -7:
                                            msg += 'la somma delle ore di Area 2a e Area 2b non coincide con le ore di Area 2 (wiz. 2). ';
                                            break;
                                        case -8:
                                            msg += 'la somma totale delle ore dei moduli deve corrispondere a quella del corso (wiz. 3). ';
                                            break;
                                        case -9:
                                            msg += 'non sono presenti docenti (wiz. 5). ';
                                            break;
                                        case -10:
                                            msg += 'non sono presenti moduli (wiz. 3). ';
                                        case -11:
                                            msg += 'non sono presenti moduli specifici (wiz. 3). ';
                                        case -12:
                                            msg += 'per percorso duale il numero minimo di ore per la formazione sul lavoro � 400 (wiz. 2). ';
                                            break;
                                    }
                                    return bDialog.informationDialog(msg);
                                }
                            }
                        });
                    },
                    function () { //NO
                        //
                    }
                );
        };

        vm.unlock = function () {
            var item = vm.record;
            var msg = 'Percorso ID:' + item.Id + ' - ' + item.Titolo;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare il ' + msg + ' ?', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_unlock(item).then(function (data) {
                        if (data == "400") return logError('Errore: operazione non consentita');

                        vm.record.Completed = false;
                        vm.records[vm.index].Completed = vm.record.Completed;

                        return logSuccess('Record sbloccato ');
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        vm.restore = function (item) {
            bDialog.confirmationDialog('Attenzione', 'Si stanno per reinizializzare i campi ricevuta e protocollo. Proseguire?', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_restore(item.Id).then(function (data) {
                        if (data == 0 || data == null || data == '' || typeof data == 'undefined') {
                            return logError('Error on Restore');
                        }

                        item.ProgressivoRicvevuta = 0;
                        item.CodiceRicvevuta = '';
                        item.DtRicvevuta = '';
                        item.NumProtSent = '';
                        item.OpProtSent = '';
                        item.DtProtSent = '';

                        var index = vm.records.indexOf(item);
                        if (index !== -1) {
                            vm.records[index] = item;
                        }

                        return logSuccess('Success on Restore');
                    });
                },
                function () { //NO

                }
            );
        };

        vm.setSent = function () {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti. Procedere?', 'SI').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return datacontext.pCorso_setSent(vm.record.Id).then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data) || typeof data == 'undefined') {
                                vm.record.Sent = false;
                                if (data == "400") return 400;
                                else if (data == "409" && vm.fTMisuraCode == '2B') return logError('Errore! Inserire almeno un percorso formativo.');
                                else if (data == "409") return logError('Errore! Nome Corso esistente!!');
                                else if (data == "406") {
                                    if (vm.fTMisuraCode == '5' || vm.fTMisuraCode == '2C' || vm.fTMisuraCode == '2B')
                                        return logError('Errore! Inserire tutti gli allegati richiesti.');
                                }
                                else if (data == "417") return logError('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                                else if (data == "502") {
                                    return logError('Attenzione: la stampa della "ricevuta" non \xE8 ancora permessa, in quanto non \xE8 il periodo utile.');
                                }

                                return true;
                            }
                            vm.printRicevuta();
                            getRecord(data.Id, vm.index);
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                vm.printRicevuta();
            }
        };

        vm.unlockSent = function () {
            if (vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'Si vuole rimuovere lo stato in "Ricevuta". Ma l\'assegnazione del codice rimmarr\xE0 a sistema. Procedere?', 'SI').then(
                    function () { //YES
                        return datacontext.pCorso_unlockSent(vm.record).then(function (data) {
                            //console.info('unlockSent()', data);
                            if (data != "204") return logError('Errore: operazione non consentita');
                            vm.record.Sent = false;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
        };

        vm.setProtSent = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/cndPCorso2BProtSent.html?version=127',
                controller: 'cndPCorso2BProtSent',
                backdrop: 'static',
                resolve: {
                    pCorso: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore. ');

                setRecord(returnItem);
                vm.records[index] = vm.record;
                logSuccess('Istanza protocollata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetProtSent = function (item, index) {
            if (item.NumProtSent != null && item.NumProtSent != "") {
                bDialog.confirmationDialog('Attenzione', 'Si sta rimuovendo il protocollo dell\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        return datacontext.pCorso_unsetProtSent(item).then(function (data) {
                            if (data == '404') return logError('Errore di aggiornamento stato. ');
                            if (typeof data == 'undefined') return logError('Errore. ');

                            setRecord(data);
                            return vm.records[index] = vm.record;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        vm.setConvalida = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/cndPCorso2BConvalida.html?version=127',
                controller: 'cndPCorso2BConvalida',
                backdrop: 'static',
                resolve: {
                    pCorso: function () {
                        return item;
                    },
                    tMisuraCode: function () {
                        return item.TMisuraCode;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '400') return logError('Errore Aggiornamento');
                if (!returnItem) return logError('Errore. ');

                setRecord(returnItem);
                vm.records[index] = vm.record;
                logSuccess('Istanza convalidata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetConvalida = function (item, index) {
            if (item.iConvalida != 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta rimuovendo la convalida dall\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        item.iConvalida = 0;
                        return datacontext.pCorso_unsetConvalida(item).then(function (data) {
                            if (typeof data == 'undefined') return logError('Errore. ');

                            setRecord(data);
                            return vm.records[index] = vm.record;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        //Elenchi Parametri
        function getAPL() {
            vm.cmblist.APL = [];
            return datacontext.azienda_getAllList('', '', 0, '', 'PROM', vm.fTMisuraCode, 0, 0, 0, '', '', '', 0).then(function (data) {
                return vm.cmblist.APL = data;
            });
        }

        function getTPercorsi() {
            if (vm.cmblist.tPercorsi.length > 0) return;

            return datacontext.tPercorso_getAllList().then(function (data) {
                return vm.cmblist.tPercorsi = data;
            });
        }

        function getTFigProfessionali() {
            if (vm.cmblist.tFigProfessionali.length > 0) return;

            return datacontext.tFigProfessionale_getAllList('IeFP3').then(function (data) {
                return vm.cmblist.tFigProfessionali = data;
            });
        }

        function getTProfiliDocenti() {
            if (vm.cmblist.tProfiloDocenti.length > 0) return;

            datacontext.tProfiloDocente_getAll().then(function (data) {
                vm.cmblist.tProfiloDocenti = data;
            });
        }

        function getTTitoloStudio() {
            if (vm.cmblist.tTitoloStudio.length > 0) return;

            datacontext.tTitoloStudio_getAllList().then(function (data) {
                vm.cmblist.tTitoloStudio = data;
            });
        }

        function getEntiSubordinati() {
            return datacontext.azienda_getAllList('', '', 0, '', 'PROM', vm.fTMisuraCode, 0, 0, 0, '', '', 3).then(function (data) {
                //console.info('getEntiSubordinati', data);
                return vm.cmblist.entiSubordinati = data;
            });
        }


        // ENTE CERTIFICATORE
        vm.reset_EnteCertificatore = function () {
            if (!vm.record.bEnteCertificatore) {
                vm.record.EnteCertif_RagioneSociale = '';
                vm.record.EnteCertif_PIVA = '';
                vm.record.EnteCertif_CF = '';
            }
        };

        // #region Corso Modulo

        vm.addCorsoMod = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/pcModulo2BAdd.html?version=127',
                controller: 'pcModulo2BAdd',
                backdrop: 'static',
                resolve: {
                    modulo: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    bModSpec: function () {
                        return false;
                    },
                    bArticolato: function () {
                        return vm.record.M2B_bArticolato;
                    },
                    tFigProfessionali: function () {
                        var arrayFP = [];

                        vm.cmblist.tFigProfessionali.forEach(function (item) {
                            if (item.Id == vm.record.TFigProfessionaleId) {
                                arrayFP.push(item);
                            }

                            if (item.Id == vm.record.M2B_Articolato_TFigProfId) {
                                arrayFP.push(item);
                            }
                        });

                        return arrayFP;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCMod.push(returnItem);
                }
                else {
                    var index = vm.record.PCMod.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCMod[index] = returnItem;
                    }
                }

                vm.getModuloSummary(vm.record.PCMod);
                vm.record.PCModChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoMod = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCModChanged = true;
            vm.getModuloSummary(vm.record.PCMod);
            return logSuccess('Elemento rimosso ');
        };

        vm.getModuloSummary = function (array) {
            vm.sumOreTotali = 0;
            vm.oreTot = 0;

            if ($.isNumeric(vm.record.A1_Ore) && $.isNumeric(vm.record.A2_Ore)) {
                vm.oreTot = parseInt(vm.record.A1_Ore + vm.record.A2_Ore);
            }

            if (typeof array == 'undefined' || array.length == 0)
                return;
            return array.forEach(function (item) {
                if (!item.Deleted && !item.M2B_bModuliSpecifici) {
                    if (!item.M2B_bSpecifico || (item.M2B_bSpecifico && item.M2B_CNDTFigProfId == vm.record.TFigProfessionaleId))
                        vm.sumOreTotali += item.M2B_Ore;
                }

                return true;
            });
        };


        // #endregion

        // #region Corso Modulo Specifici

        vm.addCorsoModSpec = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/pcModulo2BAdd.html?version=127',
                controller: 'pcModulo2BAdd',
                backdrop: 'static',
                resolve: {
                    modulo: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    bModSpec: function () {
                        return true;
                    },
                    bArticolato: function () {
                        return false;
                    },
                    tFigProfessionali: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCModSpec.push(returnItem);
                }
                else {
                    var index = vm.record.PCModSpec.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCModSpec[index] = returnItem;
                    }
                }

                vm.getModuloSpecSummary(vm.record.PCModSpec);
                vm.record.PCModSpecChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoModSpec = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCModSpecChanged = true;
            vm.getModuloSpecSummary(vm.record.PCModSpec);
            return logSuccess('Elemento rimosso ');
        };

        vm.getModuloSpecSummary = function (array) {
            vm.sumOreTotaliSpec = 0;

            if (typeof array == 'undefined' || array.length == 0)
                return;
            return array.forEach(function (item) {
                if (!item.Deleted && item.M2B_bModuliSpecifici) {
                    vm.sumOreTotaliSpec += item.M2B_Ore;
                }

                return true;
            });
        };


        // #endregion

        // #region Corso Allievo

        vm.addCorsoAllievo = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/pcAllievo2BAdd.html?version=127',
                controller: 'pcAllievo2BAdd',
                backdrop: 'static',
                resolve: {
                    allievo: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    entiSubordinati: function () {
                        return vm.cmblist.entiSubordinati;
                    },
                    aplId: function () {
                        return vm.record.APLId;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('allievo: returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCAllievi.push(returnItem);
                }
                else {
                    var index = vm.record.PCAllievi.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCAllievi[index] = returnItem;
                    }
                }

                vm.record.PCAllievoChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoAllievo = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCAllievoChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion

        // #region Corso Docente

        vm.addCorsoDocente = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/pcDocente2BAdd.html?version=127',
                controller: 'pcDocente2BAdd',
                backdrop: 'static',
                resolve: {
                    docente: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    cndPCMod: function () {
                        return vm.record.PCMod;
                    },
                    tProfiloDocenti: function () {
                        return vm.cmblist.tProfiloDocenti;
                    },
                    tTitoloStudio: function () {
                        return vm.cmblist.tTitoloStudio;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('docente: returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCDocenti.push(returnItem);
                }
                else {
                    var index = vm.record.PCDocenti.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCDocenti[index] = returnItem;
                    }
                }

                vm.record.PCDocenteChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoDocente = function (item) {
            item.Deleted = true;
            item.OpDeleted = vm.record.OpInsert;
            vm.record.PCDocenteChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion


        //------------------------------ANOMALIE------------------------------------------------------------
        function setIssueCPISolved() {
            if (vm.record.ass_Note == null)
                vm.record.ass_Note = '';

            var today = moment().format('DD/MM/YYYY');

            if (vm.record.IssueCPI != '')
                vm.record.ass_Note += '\nAnomalia CPI risolta: ' + today + ' - ' + vm.record.IssueCPIDescr;

            vm.record.IssueCPI = 0;
            vm.record.IssueCPIDescr = '';
            //vm.record.Sent = true;

            //updateItem();
            modalInviaUMC();
        }

        function setIssueAPLSolved() {
            if (vm.record.ass_Note == null)
                vm.record.ass_Note = '';

            var today = moment().format('DD/MM/YYYY');

            if (vm.record.IssueAPL != '')
                vm.record.ass_Note += '\nAnomalia APL risolta: ' + today + ' - ' + vm.record.IssueAPLDescr;

            vm.record.IssueAPL = 0;
            vm.record.IssueAPLDescr = '';
            //vm.record.Sent = true;

            //updateItem();
            //setSentCPI();
            //modalInviaUMC();
        }

        function setPresaIncarico() {
            bDialog.confirmationDialog('Attenzione', 'La richiesta di indennit\xE0 verr\xE0 "PRESA INCARICO" dall\'operatore. Proseguire?', 'OK').then(
                function () { //YES
                    vm.record.bPresaIncarico = true;
                    datacontext.pCorso_setPresaIncarico(vm.record).then(function (data) {
                        //console.dir(data);
                        if (typeof (data) == 'undefined' || data == null) {
                            vm.record.bPresaIncarico = false;
                        }
                        getRecord(vm.record.Id).then(function (data) {
                            var index = _.findIndex(vm.records, { Id: vm.record.Id });
                            vm.records[index] = vm.record;
                        });
                    });

                },
                function () { //NO
                    //vm.record.bPresaIncarico = false;
                }
            );
        }

        function unsetPresaIncarico() {
            var item = vm.record;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler rimuovere la "PRESA INCARICO" per la richiesta di indennit\xE0? ', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_unsetPresaIncarico(item).then(function (data) {
                        if (data == "404") return logError('Errore: operazione non consentita');
                        else {
                            vm.record.bPresaIncarico = false;
                            getRecord(vm.record.Id).then(function (data) {
                                var index = _.findIndex(vm.records, { Id: vm.record.Id });
                                vm.records[index] = vm.record;
                            });
                            logSuccess('Presa in carico rimossa');
                        }
                    });
                },
                function () { //NO
                    //vm.record.bPresaIncarico = false;
                }
            );
        }

        function setPresaIncaricoCPI() {
            bDialog.confirmationDialog('Attenzione', 'La richiesta di indennit\xE0 verr\xE0 "PRESA INCARICO" dall\'operatore. Proseguire?', 'OK').then(
                function () { //YES
                    vm.record.bPresaIncaricoCPI = true;
                    datacontext.pCorso_setPresaIncaricoCPI(vm.record).then(function (data) {
                        if (typeof (data) == 'undefined' || data == null) {
                            vm.record.bPresaIncaricoCPI = false;
                        }

                        getRecord(vm.record.Id).then(function (data) {
                            var index = _.findIndex(vm.records, { Id: vm.record.Id });
                            vm.records[index] = vm.record;
                        });
                    });

                },
                function () { //NO
                    //vm.record.bPresaIncaricoCPI = false;
                }
            );
        }

        function unsetPresaIncaricoCPI() {
            var item = vm.record;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler rimuovere la "PRESA INCARICO" per la richiesta di indennit\xE0? ', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_unsetPresaIncaricoCPI(item).then(function (data) {
                        if (data == "404") return logError('Errore: operazione non consentita');
                        else {
                            vm.record.bPresaIncaricoCPI = false;
                            getRecord(vm.record.Id).then(function (data) {
                                var index = _.findIndex(vm.records, { Id: vm.record.Id });
                                vm.records[index] = vm.record;
                            });
                            logSuccess('Presa in carico rimossa');
                        }
                    });
                },
                function () { //NO
                    //vm.record.bPresaIncarico = false;
                }
            );
        }

        function setIssue(item, iRole) { //Item � l'ATTACH
            if (!iRole || iRole == 0) return;

            switch (iRole) {
                case 1: //Anomalia da CPI all'APL
                    if (!vm.record.bPresaIncaricoCPI) {
                        return logError('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia presa in carico dal CPI.');
                    }
                    break;
                case 2: //Anomalia da UMC al CPI 
                    if (!vm.record.bPresaIncarico) {
                        return logError('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia presa in carico dall\'UMC.');
                    }
                    break;
                case 3: //Anomalia da UMC all'APL 
                    if (!vm.record.bPresaIncarico) {
                        return logError('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia presa in carico dall\'UMC.');
                    }
                    break;
            }

            if (vm.record.ass_Checked && !(vm.isUMC || vm.isSUPER || vm.isFAM)) {
                return logError('La pratica \xE8 verificata.');
            }

            var tSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var source = { Id: vm.record.Id, Name: vm.record.Titolo };

            var modalInstance = modal.open({
                templateUrl: '/app/STRUMENTI/issueLog/modal/issueLogAdd.html?version=127',
                controller: 'issueLogAdd',
                backdrop: 'static',
                resolve: {
                    tMisuraCode: function () {
                        return vm.fTMisuraCode;
                    },
                    tRuoloCode: function () {
                        return 'AZD_PROM-' + vm.fTMisuraCode;
                    },
                    tSource: function () {
                        return [tSource];
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    source: function () {
                        return [source];
                    },
                    sourceId: function () {
                        return vm.record.Id;
                    },
                    tDestId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return 2; //il destinatario � l'APL
                            case 2:
                                return 1; //il destinatario � il CPI
                        }
                    },
                    dest: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APL_RagioneSociale; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPI; //il destinatario � il CPI
                        }
                    },
                    destId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APLId; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPIId; //il destinatario � il CPI
                        }
                    },
                    bResponse: function () {
                        return false;
                    },
                    iRole: function () {
                        return iRole;
                    },
                    issueLog: function () {
                        return undefined;
                    },
                    bozza: function () {
                        return false;
                    },
                    showDtScad: function () {
                        return false;
                    },
                    attachId: function () {
                        return item.Id;
                    }

                }
            });

            modalInstance.result.then(function (returnItem) {
                console.log('returnItem %s', returnItem);
                //returnItem � undefined perch� il js risponde prima di C#
                if (returnItem && returnItem == "409") return logError('errore di creazione! ');

                setTimeout(function () { getListAttach(vm.record.Id); }, 200);                
                return logSuccess('Dato salvato con successo! ');                
            }, function () {
                //
            });

        }

        function unsetIssue(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name, Code: "CRS_2B" };
            var recSource = { Id: vm.record.Id, Name: vm.record.Titolo };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd.html?version=127',
                controller: 'attachAdd',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return recTSource.Code;
                    },
                    tSourceId: function () {
                        return recTSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return null;
                    },
                    tAttachId: function () {
                        return null;
                    },
                    attach: function () {
                        return item;
                    },
                    anomalia: function () {
                        return true;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Errore: allegato non inseribile! ');
                if (!returnItem) return logError('errore di creazione! ');

                getListAttach(vm.record.Id);
                logSuccess('Anomalia allegato risolta');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }



        function addIssueLog(item, bResp, iRole) {
            switch (iRole) {
                case 1: //Anomalia da CPI all'APL 
                    if (!vm.record.bPresaIncaricoCPI)
                        return logError('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia stata presa in carico.');
                    break;
                case 2: //Anomalia da UMC al CPI 
                    if (!vm.record.bPresaIncarico)
                        return logError('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia stata presa in carico.');
                    break;
                case 3: //Anomalia da UMC all'APL 
                    if (!vm.record.bPresaIncarico)
                        return logError('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia stata presa in carico.');
                    break;
            }

            if (vm.record.ass_Checked) return;

            var tSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var source = { Id: vm.record.Id, Name: vm.record.Titolo };

            var modalInstance = modal.open({
                templateUrl: '/app/STRUMENTI/issueLog/modal/issueLogAdd.html?version=127',
                controller: 'issueLogAdd',
                backdrop: 'static',
                resolve: {
                    tMisuraCode: function () {
                        return vm.fTMisuraCode;
                    },
                    tRuoloCode: function () {
                        return 'AZD_PROM-' + vm.fTMisuraCode;
                    },
                    tSource: function () {
                        return [tSource];
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    source: function () {
                        return [source];
                    },
                    sourceId: function () {
                        return vm.record.Id;
                    },
                    tDestId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return 2; //il destinatario � l'APL
                            case 2:
                                return 1; //il destinatario � il CPI
                        }
                    },
                    dest: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APL; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPI; //il destinatario � il CPI
                        }
                    },
                    destId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APLId; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPIId; //il destinatario � il CPI
                        }
                    },
                    bResponse: function () {
                        return bResp;
                    },
                    iRole: function () {
                        return iRole;
                    },
                    issueLog: function () {
                        return item;
                    },
                    bozza: function () {
                        return true;
                    },
                    showDtScad: function () {
                        return false;
                    },
                    attachId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "409") return logError('errore di creazione! ');

                logSuccess('Dato salvato con successo! ');

                switch (iRole) {
                    case 1: //Anomalia da CPI all'APL 
                        return getListIssuesLog(vm.record.Id, vm.record.APLId, iRole);
                    case 2: //Anomalia da UMC al CPI 
                        return getListIssuesLog(vm.record.Id, vm.record.CPIId, iRole);
                    case 3: //Anomalia da UMC all'APL 
                        return getListIssuesLog(vm.record.Id, vm.record.APLId, iRole);
                }
            }, function () {
                //
            });

        }

        function getListIssuesLog(sourceId, destId, iRole) {
            if (!sourceId || !destId) return;
            switch (iRole) {
                case 1: //Anomalia da CPI all'APL 
                    return getArrayIssues(sourceId, destId, iRole).then(function (data) {
                        return vm.list.issueCPILog = data;
                    });
                case 2: //Anomalia da UMC al CPI 
                    return getArrayIssues(sourceId, destId, iRole).then(function (data) {
                        return vm.list.issueUMCLog = data;
                    });
                case 3: //Anomalia da UMC all'APL 
                    return getArrayIssues(sourceId, destId, iRole).then(function (data) {
                        return vm.list.issueLog = data;
                    });
            }
        }

        function getArrayIssues(sourceId, destId, iRole) {
            var iState = -2; //Tutte
            return datacontext.issueLog_getAll(0, 0, '', 0, sourceId, 0, destId, 0, iState, iRole, '').then(function (data) {
                //console.info('getArrayIssues', data);
                return data;
            });
        }

        function setIState(item, iState, iRole) {
            if (!item) return;
            var tmpIState = item.iState;

            var msg = '';
            switch (iState) {
                case 0:
                    msg = 'Si sta "trasmettendo" l\'anomalia. Procedere? ';
                    break;
                case 2:
                    msg = 'Si sta "risolvendo" l\'anomalia. Procedere? ';
                    break;
                case 3:
                    msg = 'Si sta "rifiutando" di risolvere l\'anomalia; per proseguire \xE8 necessario fornire una motivazione. Procedere?';
                    break;
                default: // metti in lavorazione
                    return fn_setIState(item, iState, iRole);
            }

            bDialog.confirmationDialog('Attenzione', msg, 'Prosegui').then(
                function () { //YES
                    if (iState == 3) { //"Non risolvi"
                        addIssueLog(item, true, iRole);
                    }
                    else {
                        fn_setIState(item, iState, iRole);
                    }
                },
                function () { //NO
                    item.iState = tmpIState;
                    return;
                }
            );
        }

        function fn_setIState(issue, iState, iRole) {
            return datacontext.issueLog_setState(issue.Id, iState).then(function (data) {
                if (data == "400") return logError('Errore generico.');
                if (data == "409") return logError('Errore modifica dati.');

                issue.iState = iState;
                switch (iRole) {
                    case 1: //Anomalia da CPI all'APL 
                        var index2 = vm.list.issueCPILog.indexOf(issue);
                        vm.list.issueCPILog[index2] = data;
                        break;
                    case 2: //Anomalia da UMC al CPI 
                        var index = vm.list.issueUMCLog.indexOf(issue);
                        vm.list.issueUMCLog[index] = data;
                        break;
                    case 3: //Anomalia da UMC all'APL 
                        var index = vm.list.issueLog.indexOf(issue);
                        vm.list.issueLog[index] = data;
                        break;
                }

                logSuccess('Record Salvato ');
                //getRecord(vm.record.Id);
            });
        }

        function deleteIssueLog(item, iRole) {
            //var Index = index;
            var msg = ' Anomalia: ' + item.Description;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.issueLog_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    switch (iRole) {
                        case 1: //Anomalia all'APL da CPI
                            var index = vm.list.issueCPILog.indexOf(item);
                            vm.list.issueCPILog.splice(index, 1);
                            break;
                        case 2: //Anomalia al CPI da UMC
                            var index = vm.list.issueUMCLog.indexOf(item);
                            vm.list.issueUMCLog.splice(index, 1);
                            break;
                        case 3: //Anomalia all'APL da UMC
                            var index = vm.list.issueLog.indexOf(item);
                            vm.list.issueLog.splice(index, 1);
                            break;
                    }

                });
            });
        }


        //STAMPA ANOMALIE
        function printAnomalie(elem) {
            if (elem) { //se esitono anomalie
                var mywindow = window.open('', 'PRINT', 'height=400,width=600');

                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('</head><body >');
                mywindow.document.write('<h1>Fascicolo Anomalie</h1>');
                mywindow.document.write('<h3>Richiesta di indennit&agrave; Id:' + elem[0].SourceId + ' ' + elem[0].Source + '</h3>');
                //mywindow.document.write(document.getElementById(elem).innerHTML);
                mywindow.document.write('<table><tr><td width="10%"><span style="font-weight:bold">Stato</span></td><td width="5%"><span style="font-weight:bold">Id</span></td><td width="15%"><span style="font-weight:bold">Data</span></td><td width="70%"><span style="font-weight:bold">Descrizione</span></td></tr>');

                for (var i = 0; i < elem.length; i++) {
                    if (elem[i].Description == null) elem[i].Description = "";
                    if (elem[i].Response == null) elem[i].Response = "";
                    var anno = elem[i].DtInsert.toString().substring(0, 4);
                    var mese = elem[i].DtInsert.toString().substring(5, 7);
                    var giorno = elem[i].DtInsert.toString().substring(8, 10);

                    var stato = "";
                    switch (elem[i].iState) {
                        case -1:
                            stato = "bozza";
                            break;
                        case 0:
                            stato = "Anom. trasmessa all'APL";
                            break;
                        case 1:
                            stato = "Anom. in lavorazione";
                            break;
                        case 2:
                            stato = "Anom. risolta";
                            break;
                        case 3:
                            stato = "Anom. non risolta";
                            break;

                        default:
                    }
                    mywindow.document.write('<tr>' + '<td style="vertical-align: top">' + stato + '</td>' + '<td style="vertical-align: top">' + elem[i].Id + '</td>' + '<td style="vertical-align: top">' + giorno + "/" + mese + "/" + anno + '</td>' + '<td style="vertical-align: top">' + elem[i].Description + '</td></tr>');
                    if (elem[i].Response != "") {
                        mywindow.document.write('<tr>' + '<td colspan="3">&nbsp;</td><td><span style="font-weight:bold">Motivazione</span></td></tr>');
                        mywindow.document.write('<tr>' + '<td colspan="3">&nbsp;</td><td>' + elem[i].Response + '</td></tr>');
                    }
                    mywindow.document.write('<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>');
                }
                mywindow.document.write('</table>');
                mywindow.document.write('</body></html>');
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                mywindow.print();
                mywindow.close();
                return true;
            }
        }
        //------------------------------FINE ANOMALIE-------------------------------------------------------


        // #region STAMPA ALLEGATI E RICEVUTA

        vm.printAllegato = function (index) {
            var msg = '';
            if (!vm.record.Completed) {
                msg = 'L\'allegato verr\xE0 stampato in bozza. Procedere? ';
            }
            else {
                msg = 'L\'allegato verr\xE0 stampato. Procedere? ';
            }
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    vm.printing = true;
                    $('#loadingModal').modal('show');

                    return datacontext.pdf_printAttach2(0, vm.tSourceCode_def, vm.record.Id, 0, index).then(function (response) {
                        vm.printing = false;
                        $('#loadingModal').modal('hide');
                        var status = response.status;
                        var data = response.data;

                        if (response == null || $.isNumeric(status)) {
                            if (status == 417) {
                                return logError('Attenzione si \xE8 verificato il seguente problema: ' + data);
                            }
                            return logError('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                        }
                        else if (response && response.url) {
                            var url = response.url;
                            var name = 'Allegato' + index + '_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';

                            window.open(url, name);

                            //recupero allegato appena creato
                            //var a = document.createElement("a");
                            //a.setAttribute('style', 'display:none');
                            //a.setAttribute('target', '_blank');
                            //document.body.appendChild(a);

                            //a.href = response.url;
                            //if ($rootScope.detectIE()) {
                            //    a.target = 'hiddenIframe';
                            //}
                            //else
                            //    a.download = 'Allegato' + index + '_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';
                            //a.click();
                            //document.body.removeChild(a);

                            return response.url;
                        } else
                            return true;
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        vm.printRicevuta = function () {
            if (vm.record.Sent) {
                $('#loadingModal').modal('show');

                return datacontext.pdf_printRicevuta2(0, vm.tSourceCode_def, vm.record.Id).then(function (response) {
                    $('#loadingModal').modal('hide');
                    var status = response.status;
                    var data = response.data;

                    if (response == null || $.isNumeric(status)) {
                        if (status == 417) {
                            return logError('Attenzione si \xE8 verificato il seguente problema: ' + data);
                        }
                        return logError('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                    }
                    else if (response && response.url) {

                        var url = response.url;
                        var name = 'RicevutaID' + vm.record.Id + '.pdf';

                        window.open(url, name);

                        //recupero allegato appena creato
                        //var a = document.createElement("a");
                        //a.setAttribute('style', 'display:none');
                        //a.setAttribute('target', '_blank');
                        //document.body.appendChild(a);

                        //a.href = response.url;
                        //if ($rootScope.detectIE()) {
                        //    a.target = 'hiddenIframe';
                        //}
                        //else
                        //    a.download = 'RicevutaID' + vm.record.Id + '.pdf';
                        //a.click();
                        //document.body.removeChild(a);

                        return response.url;
                    } else
                        return true;
                });
            }
        };

        // #endregion

        // #region PANNELLO ATTACH
        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }
        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getListAttach(id) {
            if (!id) return;

            if (vm.fAttach.TAttachId == '' || vm.fAttach.TAttachId == null || typeof vm.fAttach.TAttachId == 'undefined') {
                vm.fAttach.TAttachId = 0;
            }

            return datacontext.attach_getAll(0, 0, id, 0, vm.tSourceCode_def, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;

                return datacontext.tAttachVisibility_getAuth(vm.tSourceCode_def).then(function (data_TAV) {
                    var tAttVis = data_TAV;

                    vm.list.attach.forEach(function (item_A) {
                        var myTAV = _.find(tAttVis, { 'TAttachId': item_A.TAttachId });

                        if (typeof myTAV == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        item_A.bRead = myTAV.bRead;
                        item_A.bInsert = myTAV.bInsert;
                        item_A.bUpdate = myTAV.bUpdate;
                        item_A.bDelete = myTAV.bDelete;
                        item_A.iTags = myTAV.iTags;

                        if (!item_A.bRead) {
                            var index = vm.list.attach.indexOf(item_A);
                            vm.list.attach.splice(index, 1);
                        }

                    });

                    return vm.list.attach = data;
                });
            });
        }

        vm.addAttach = function (item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.Titolo };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd.html?version=127',
                controller: 'attachAdd',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        var tatt = typeof item == 'undefined' ? null : vm.tAttach;
                        return tatt;
                    },
                    tAttachId: function () {
                        var tattid = typeof item == 'undefined' ? null : item.TAttachId;
                        return tattid;
                    },
                    attach: function () {
                        return item;
                    },
                    anomalia: function () {
                        return false;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "417") return logError('Attenzione: entit\xE0 bloccata o termini di presentazione scaduti. ');
                if (returnItem == "401") return logError('Attenzione: azione non autorizzata. ');
                if (returnItem == "406") return logError('Attenzione: allegato non permesso o termini di presentazione scaduti. ');
                if (returnItem == "409") return logError('Attenzione: allegato alterato rispetto all\'originale. ');
                if ($.isNumeric(returnItem)) return logError('Attenzione: errore generico. ');
                //Documenti con hashcode diverso da originale ma non bloccante
                if (returnItem.alert != null) { bDialog.informationDialog(returnItem.alert); }

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);

            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteAttach = function (item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: entit\xE0 bloccata o termini di presentazione scaduti. ');
                    if (data == "401") return logError('Attenzione: azione non autorizzata. ');
                    if (data == "404") return logError('Attenzione: entit\xE0 inesistente. ');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                });
            });
        };



        // #endregion

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/cndPCorso2BAdd.html?version=127',
                controller: 'cndPCorso2BAdd',
                backdrop: 'static',
                resolve: {
                    apl: function () {
                        return vm.cmblist.APL;
                    },
                    aplId: function () {
                        return typeof vm.risorsa == 'undefined' || vm.risorsa == null ? null : vm.risorsa.AziendaId;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                if (returnItem == "400") return logError('Attenzione: raggiunto il numero massimo di corsi ammessi per il Catalogo.');
                if (!returnItem) return logError('errore di creazione! ');

                logSuccess('record creato con successo! ');
                addRecord(returnItem.Id);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }




        // #region VERIFICA PARTITA IVA E CODICE FISCALE

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.checkPIVA = function (value) {
            vm.validPIVA = true;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            vm.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.checkCF = function (value) {
            vm.validCF = true;
            var isEnte = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            if (value.length == 11) isEnte = true;
            vm.validCF = false;
            return datacontext.validazione_cf(value, isEnte).then(function (data) {
                return vm.validCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID DATE -#-#-#-#-#-#
        vm.validDate = true;
        vm.change_Dates = function () {
            vm.validDate = true;
            if (vm.record.DtStartPrev != null && vm.record.DtStartPrev != '' && typeof vm.record.DtStartPrev != 'undefined'
                && vm.record.DtEndPrev != null && vm.record.DtEndPrev != '' && typeof vm.record.DtEndPrev != 'undefined'
            ) {
                var dtStartPrev = moment(vm.record.DtStartPrev).format('YYYY-MM-DD');
                var dtEndPrev = moment(vm.record.DtEndPrev).format('YYYY-MM-DD');
                //console.info('vm.change_Dates()', dtStartPrev, dtEndPrev);

                vm.validDate = moment(dtStartPrev).isBefore(dtEndPrev);
            }

            return vm.validDate;
        };




        // #endregion

    }
})();
